var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogowhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.08 7.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #d5d0ca;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.22,
    y1: 0.1,
    x2: -0.76,
    y2: 5.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e95c28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#e96425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#ec7c1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#f0a415"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f5d907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f7e704"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.43,
    y1: 7.56,
    x2: 6.84,
    y2: 0.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f58523"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#f58921"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f5951d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f5aa17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#f6c70e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f7e704"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.58,5c.46.25.91.37,1.37.09.23-.14.25-.38.24-.58-.25.07-.5.19-.74.18-.24-.01-.5-.11-.69-.26-.48-.37-.48-.89-.34-1.42.15-.53.57-.77,1.08-.84.71-.1,1.2.2,1.3.91.09.64.1,1.3.01,1.94-.09.69-.82,1.03-1.61.86-.46-.1-.66-.38-.61-.88Zm1.58-1.64c0-.36-.2-.57-.51-.57-.32,0-.56.27-.57.63,0,.32.23.55.54.55.33,0,.54-.25.54-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m25.06,3.55c-.02.58-.15,1.06-.64,1.34-.47.27-.96.24-1.43-.04-.45-.27-.69-.96-.56-1.57.12-.57.46-.96,1.04-1.1.55-.13,1.12.09,1.41.59.13.23.17.5.18.78Zm-.68.14c-.03-.16-.04-.31-.08-.46-.07-.24-.23-.39-.49-.42-.22-.02-.43,0-.54.23-.17.35-.19.72-.02,1.07.06.12.19.23.32.29.41.17.78-.17.81-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.38,3.98c.03.22.18.38.38.43.2.05.42.06.63.03.2-.03.39-.12.58-.19,0,.57-.12.72-.7.81-.75.12-1.45-.33-1.63-1.05-.19-.78.22-1.57.95-1.8.76-.24,1.48.26,1.49,1.02,0,.32-.11.51-.42.58-.41.09-.83.12-1.27.17Zm0-.53c.27-.02.51-.02.75-.07.11-.02.27-.14.27-.22,0-.11-.1-.3-.19-.33-.18-.05-.4-.06-.57,0-.22.08-.28.31-.26.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.3,3.94c.13.54.75.65,1.6.31.04.33-.04.53-.31.65-.52.23-1.06.26-1.52-.11-.5-.4-.6-.97-.48-1.58.11-.53.44-.87.96-1.01.72-.2,1.38.24,1.46.96.04.39-.18.67-.57.7-.38.03-.75.05-1.14.08Zm0-.5c.27-.02.52-.02.75-.07.1-.02.25-.15.26-.24.01-.1-.09-.28-.18-.31-.17-.05-.38-.06-.54,0-.23.09-.31.32-.29.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.04,4.96c-.52.06-.7-.1-.71-.58,0-.33-.03-.67-.05-1-.02-.34-.21-.55-.49-.54-.29,0-.5.24-.51.57,0,.43,0,.86,0,1.29,0,.09,0,.17,0,.25-.48.09-.69-.08-.69-.54,0-.36,0-.72,0-1.08,0-.65.43-1.12,1.08-1.17.73-.06,1.26.33,1.35.99.02.12.02.25.02.37,0,.47,0,.95,0,1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m28.07,4.97c-.57.04-.72-.1-.72-.65,0-.35.01-.7-.02-1.05-.03-.31-.25-.5-.52-.49-.27.01-.48.24-.49.55,0,.46,0,.91,0,1.37,0,.09,0,.17,0,.25-.54.07-.69-.05-.69-.56,0-.37,0-.74,0-1.11,0-.6.39-1.04,1-1.13.84-.11,1.43.39,1.44,1.23,0,.52,0,1.04,0,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.1,2.89c-.77-.1-.89.01-.89.78,0,.41,0,.83,0,1.24,0,.02-.01.03-.02.05-.5.09-.68-.05-.67-.53,0-.49-.02-.99.04-1.48.07-.56.76-.92,1.28-.7.23.1.3.28.26.64Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m.48,5.45s-.96-1.48-.17-3.36C.31,2.09,1.14.08,3.52,0,3.52,0,5.53,0,5.52.86c0,0,.04.77-2.36.99,0,0,.92-.45.3-1.07,0,0-.61-.45-2,.62,0,0-1.9,1.36-.98,4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m5.26.4s1.51.69,1.37,1.95c0,0-.05.93-1.34,1.19l-.56.11s-1.96-.01-2.32,1.35c0,0-.32,1.68,1.85,1.61,0,0,1.48,0,2.61-1.54,0,0-.82,2.27-3.57,2.16,0,0-2.25-.06-2.59-2.47,0,0-.34-1.93,1.89-2.74,0,0,.39-.16.7-.18,0,0,2.92-.3,1.96-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m4.95,4.37s.62-.78,1.13-.84c0,0,.78-.08.96.77,0,0,.13.62-.45,1.2,0,0-1.06,1.19-2.67,1.1,0,0-1.33,0-1.5-1.13,0,0-.17-.79.52-1.28,0,0-.22.76.38.94,0,0,.72.31,1.63-.75Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogowhite);
export default __webpack_public_path__ + "static/media/logo white.df6162676cdc9c7733677dab84ccef51.svg";
export { ForwardRef as ReactComponent };